import React from 'react'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { ButtonBase, Icon, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { Tooltip } from '@michelin/acid-components'
import PropTypes from 'prop-types'

const styles = theme => ({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
		minWidth: 140,
		width: '100%',
	},
	button: {
		width: 'auto',
		padding: '0 16px',
		minWidth: '48px',
		minHeight: '48px',
		lineHeight: '1.4em',
		color: 'rgba(0, 0, 0, 0.87)',
		backgroundColor: '#e0e0e0',
		fontWeight: '500',
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		textTransform: 'uppercase',
		boxShadow: '0px 3px 5px 1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.1)',
	},
	buttonLeft: {
		borderTopLeftRadius: '24px',
		borderBottomLeftRadius: '24px',
		paddingRight: '12px',
		marginRight: '0px',
		borderRight: '1px solid #ccc',
	},
	buttonRight: {
		borderTopRightRadius: '24px',
		borderBottomRightRadius: '24px',
		paddingLeft: '12px',
		marginLeft: '0px',
	},
	buttonPrimary: {
		color: theme.palette.primary.contrastText,
		backgroundColor: theme.palette.primary.main,
		'&:hover': {
			backgroundColor: theme.palette.primary.light
		},
	},
	buttonSecondary: {
		color: theme.palette.secondary.contrastText,
		backgroundColor: theme.palette.secondary.main,
		'&:hover': {
			backgroundColor: theme.palette.secondary.light
		},
	},
	leftIcon: {
		marginRight: theme.spacing.unit,
	},
	rightIcon: {
		marginLeft: theme.spacing.unit,
	},
	menuItem: {
		'&:focus': {
			backgroundColor: theme.palette.primary.main,
			'& $primary, & $icon': {
				color: theme.palette.common.white,
			},
		},
	},
	primary: {},
	icon: {},
})

class SplitButton extends React.Component {
	/**
	 * Default constructor object
	 * @param {props} props - the initial props object
	 * @returns {void} returns void
	 * @public
	 */
	constructor(props) {
		super(props)

		this.state = {
			anchorEl: null, 
		}

		this.handleMenuOpen = this.handleMenuOpen.bind(this)
		this.handleMenuClose = this.handleMenuClose.bind(this)
		this.onClick = this.onClick.bind(this)
	}

	handleMenuOpen(event) {
		this.setState({ anchorEl: event.currentTarget })
	}

	handleMenuClose() {
		this.setState({ anchorEl: null })
	}

	onClick(event, index, handler) {
		this.setState({ anchorEl: null })

		if (handler) {
			handler(event)
		}
	}

	render() {
		const { classes, action, menuItems } = this.props
		const { anchorEl } = this.state

		let colorClassname = classes.buttonDefault

		if (action.color === 'primary') {
			colorClassname = classes.buttonPrimary
		}
		if (action.color === 'secondary') {
			colorClassname = classes.buttonSecondary
		}

		return(
			<div className={classes.root}>
				<Tooltip title={action.hint ? action.hint : ''}>
					<ButtonBase className={classNames(classes.button, classes.buttonLeft, colorClassname)} disabled={action.disabled} onClick={action.onClick}>
						{action.icon &&
						<Icon className={classNames(classes.leftIcon, classes.iconSmall)}>
							{action.icon}
						</Icon>}
					
						{action.label && <span>{action.label}</span>}
					</ButtonBase>
				</Tooltip>

				<ButtonBase
					className={classNames(classes.button, classes.buttonRight, colorClassname)} 
					aria-owns={anchorEl ? 'split-menu' : undefined}
					aria-haspopup="true"
					onClick={this.handleMenuOpen}
				>
					<Icon className={classes.iconSmall}>arrow_drop_down</Icon>
				</ButtonBase>

				{menuItems && 
				<Menu
					id="split-menu"
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={this.handleMenuClose}
				>
					{menuItems.map((menuItem, index) => (
						<MenuItem key={index} className={classes.menuItem} onClick={event => this.onClick(event, index, menuItem.onClick)} disabled={menuItem.disabled}>
							{menuItem.icon &&
							<ListItemIcon className={classes.icon}>
								<Icon className={classes.iconMenu}>
									{menuItem.icon}
								</Icon>
							</ListItemIcon>
							}

							{menuItem.label &&
							<ListItemText classes={{ primary: classes.primary}} inset primary={menuItem.label} />}
						</MenuItem>
					))
					}
				</Menu>
				}
			</div>
		)
	}
}


SplitButton.propTypes = {
	classes: PropTypes.object,
	action: PropTypes.shape({
		icon: PropTypes.string,
		onClick: PropTypes.func,
		label: PropTypes.string,
		hint: PropTypes.string,
		disabled: PropTypes.bool,
		color: PropTypes.oneOf(['default', 'primary', 'secondary']),
	}).isRequired,
	menuItems: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.string,
			onClick: PropTypes.func,
			label: PropTypes.string,
			hint: PropTypes.string,
			disabled: PropTypes.bool,
			color: PropTypes.oneOf(['default', 'primary', 'secondary']),
		})
	)
}

SplitButton.defaultProps = {
}

export default withStyles(styles)(SplitButton)


// WEBPACK FOOTER //
// ./src/components/SplitButton.jsx